import { useQuery } from '@tanstack/react-query';
import { useApiClients } from '../../client/api/useApiClient';
import CustomQuestions from '../../views/CustomQuestions';
import Loader from '../../components/Loader';
import {
  GetAllInvestigationQuestionCategoryOfOrganizationResponse,
  GetAllInvestigationQuestionOfOrganizationResponse,
} from '@EHSNavigator/backend';

export default function CustomQuestionsPage() {
  const { InvestigationQuestionCategoryApi, InvestigationQuestionApi } =
    useApiClients();

  const {
    data: allInvestigationQuestions,
    isLoading: isInvestigationQuestionsLoading,
  } = useQuery<GetAllInvestigationQuestionOfOrganizationResponse, Error, any>({
    queryKey: ['all-investigation-questions'],
    queryFn: async () => {
      const response =
        await InvestigationQuestionApi?.investigationQuestionControllerFindAllInvestigationQuestion(
          {
            search: '',
          },
        );
      return response?.data;
    },
  });

  const {
    data: allInvestigationQuestionCategories,
    isLoading: isInvestigationQuestionCategoriesLoading,
    refetch,
  } = useQuery<
    GetAllInvestigationQuestionCategoryOfOrganizationResponse,
    Error,
    any
  >({
    queryKey: ['all-investigation-question-categories'],
    queryFn: async () => {
      const response =
        await InvestigationQuestionCategoryApi?.investigationQuestionCategoryControllerFindAllInvestigationQuestionCategory(
          {
            search: '',
          },
        );
      return response?.data;
    },
  });

  if (
    isInvestigationQuestionsLoading ||
    isInvestigationQuestionCategoriesLoading
  ) {
    return <Loader />;
  }
  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <CustomQuestions
        allInvestigationQuestionCategories={allInvestigationQuestionCategories}
        allInvestigationQuestions={allInvestigationQuestions}
        categoriesRefetch={refetch}
      />
    </div>
  );
}
